// extracted by mini-css-extract-plugin
module.exports = {"footer":"PageFooter_footer__2KDIw","footerCopyright":"PageFooter_footerCopyright__1r2th","footerMessage":"PageFooter_footerMessage__1PP9y"};